import CampaignMultiselect from './CampaignMultiselect';

export default CampaignMultiselect;
